import api from '../../Axios'; // Adjust this path to your core Axios instance

export const expertWalletApi = {
  /**
   * Fetch comprehensive wallet metrics, current month earnings, 
   * and annual 12-month calendar breakdown array balances.
   */
  getWalletOverview: async () => {
    const response = await api.get('/api/expert/wallet/overview');
    return response.data;
  }
};